<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="语言" required class="locale-select-item">
        <a-select
          mode="multiple"
          v-model="selectedLocales"
          placeholder="请选择语言"
          class="locale-select"
          :maxTagCount="4"
          :allowClear="false"
          @change="handleLocaleChange"
        >
          <a-select-option v-for="item in localeFields" :key="item.key" :value="item.key">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <div v-for="item in visibleLocaleFields" :key="item.key" class="locale-block">
        <a-form-model-item :label="item.label + '轮播图'" :prop="item.bannerUrl">
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form[item.bannerUrl]"
            :showUploadList="false"
            :beforeUpload="file => beforeBannerUpload(item.bannerUrl, file)"
            :customRequest="info => handleBannerUpload(item.bannerUrl, info)"
          >
            <div v-if="form[item.bannerUrl]" class="upload-image-wrapper">
              <img :src="form[item.bannerUrl]" alt="banner" style="height:104px;max-width:300px"/>
              <div v-if="bannerUploadLoading[item.bannerUrl]" class="upload-mask">
                <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>
              </div>
            </div>
            <div v-else>
              <a-icon :type="bannerUploadLoading[item.bannerUrl] ? 'loading' : 'plus'"/>
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </a-form-model-item>

        <a-form-model-item :label="item.label + '视频'" :prop="item.videoUrl">
          <a-upload
            listType="picture-card"
            accept=".mp4"
            class="avatar-uploader video-uploader"
            v-model="form[item.videoUrl]"
            :showUploadList="false"
            :customRequest="info => handleVideoUpload(item, info)"
          >
            <div v-if="form[item.videoUrl]">
              <video :src="form[item.videoUrl]" width="300" height="150" controls></video>
            </div>
            <div v-else>
              <a-icon :type="videoUploadLoading[item.videoUrl] ? 'loading' : 'plus'"/>
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
          <a-progress
            style="margin-top: 10px;margin-bottom: 10px;width: 20%"
            v-if="videoUploadProgress[item.videoUrl]"
            :percent="videoUploadProgress[item.videoUrl]"
          />
        </a-form-model-item>
      </div>

      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入排序"/>
      </a-form-model-item>
      <a-form-model-item label="类型" prop="imgType">
        <a-select placeholder="请选择" v-model="form.imgType">
          <a-select-option :key="0">轮播图</a-select-option>
          <a-select-option :key="1">广告图</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="跳转类型" prop="type">
        <a-select placeholder="请选择跳转类型" @change="updateType" v-model="form.type">
          <a-select-option :key="0">短剧</a-select-option>
          <a-select-option :key="1">外部链接</a-select-option>
          <a-select-option :key="2">充值页面</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.type==0" label="是否跳转" prop="isJump">
        <a-select placeholder="请选择是否跳转" @change="updateIsGo" v-model="form.isJump">
          <a-select-option :key="false">否</a-select-option>
          <a-select-option :key="true">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.type==1" label="外部链接" prop="linkUrl">
        <a-input v-model="form.linkUrl" placeholder="请输入外部链接"/>
      </a-form-model-item>
      <a-form-model-item v-if="this.isJup && this.type==0" label="短剧" prop="videoId">
        <a-select
          v-model="form.videoId"
          showSearch
          style="width: 100%"
          placeholder="请选择短剧"
          allow-clear
          optionFilterProp="children"
        >
          <a-select-option :value="item.id" :key="item.id" :title="item.videoNameEn" v-for="(item,index) in listAll">
            {{ item.videoNameEn }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBanner, addBanner, updateBanner } from '@/api/banner/banner'
import { listVideo } from '@/api/video/video'
import UploadFileToVOD from '@/api/vod.js'

const LOCALE_FIELDS = [
  { key: 'zh', label: '中文简体', bannerUrl: 'bannerUrl', videoUrl: 'videoUrl' },
  { key: 'tc', label: '中文繁体', bannerUrl: 'bannerUrlTc', videoUrl: 'videoUrlTc' },
  { key: 'en', label: '英文', bannerUrl: 'bannerUrlEn', videoUrl: 'videoUrlEn' },
  { key: 'jp', label: '日语', bannerUrl: 'bannerUrlJp', videoUrl: 'videoUrlJp' },
  { key: 'ko', label: '韩语', bannerUrl: 'bannerUrlKo', videoUrl: 'videoUrlKo' },
  { key: 'fr', label: '法语', bannerUrl: 'bannerUrlFr', videoUrl: 'videoUrlFr' },
  { key: 'ab', label: '阿拉伯语', bannerUrl: 'bannerUrlAb', videoUrl: 'videoUrlAb' },
  { key: 'vi', label: '越南语', bannerUrl: 'bannerUrlVi', videoUrl: 'videoUrlVi' }
]

const DEFAULT_SELECTED_LOCALES = ['zh']

function buildLocaleFormFields () {
  const fields = {}
  LOCALE_FIELDS.forEach(item => {
    fields[item.bannerUrl] = null
    fields[item.videoUrl] = null
  })
  return fields
}

function buildBannerUploadLoading () {
  const loading = {}
  LOCALE_FIELDS.forEach(item => {
    loading[item.bannerUrl] = false
  })
  return loading
}

function buildVideoUploadLoading () {
  const loading = {}
  LOCALE_FIELDS.forEach(item => {
    loading[item.videoUrl] = false
  })
  return loading
}

function buildVideoUploadProgress () {
  const progress = {}
  LOCALE_FIELDS.forEach(item => {
    progress[item.videoUrl] = 0
  })
  return progress
}

function hasLocaleContent (form, item) {
  return !!(form[item.bannerUrl] || form[item.videoUrl])
}

function getBaseFormFields () {
  return {
    id: null,
    sort: null,
    videoId: null,
    isJump: false,
    linkUrl: null,
    bannerType: null,
    imgType: null,
    type: null,
    createTime: null,
    remark: null,
    ...buildLocaleFormFields()
  }
}

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      localeFields: LOCALE_FIELDS,
      selectedLocales: [...DEFAULT_SELECTED_LOCALES],
      bannerUploadLoading: buildBannerUploadLoading(),
      videoUploadLoading: buildVideoUploadLoading(),
      videoUploadProgress: buildVideoUploadProgress(),
      type: 0,
      listAll: [],
      isJup: false,
      form: getBaseFormFields(),
      formType: 1,
      open: false,
      rules: {
        sort: [
          { required: true, message: '排序不能为空' }
        ],
        isJump: [
          { required: true, message: '是否跳转不能为空' }
        ],
        linkUrl: [
          { required: true, message: '外部链接不能为空' }
        ]
      }
    }
  },
  filters: {},
  created () {
    this.getGather()
  },
  computed: {
    visibleLocaleFields () {
      return this.localeFields.filter(item => this.selectedLocales.includes(item.key))
    }
  },
  watch: {},
  mounted () {
  },
  methods: {
    handleLocaleChange (value) {
      if (!value || value.length === 0) {
        this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
        this.$message.warning('请至少选择一种语言')
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    resolveSelectedLocalesFromData (data) {
      const keys = LOCALE_FIELDS
        .filter(item => hasLocaleContent(data || {}, item))
        .map(item => item.key)
      return keys.length ? keys : [...DEFAULT_SELECTED_LOCALES]
    },
    validateLocaleContent () {
      if (!this.selectedLocales || this.selectedLocales.length === 0) {
        this.$message.error('请至少选择一种语言')
        return false
      }
      const hasOneFilled = this.visibleLocaleFields.some(item => hasLocaleContent(this.form, item))
      if (!hasOneFilled) {
        this.$message.error('至少选择一种语言上传轮播图或视频，不能全部为空')
        return false
      }
      return true
    },
    loadFormFromApi (data) {
      const form = { ...getBaseFormFields(), ...(data || {}) }
      LOCALE_FIELDS.forEach(item => {
        form[item.bannerUrl] = data && data[item.bannerUrl] != null ? data[item.bannerUrl] : ''
        form[item.videoUrl] = data && data[item.videoUrl] != null ? data[item.videoUrl] : ''
      })
      this.form = form
      this.selectedLocales = this.resolveSelectedLocalesFromData(form)
    },
    handleBannerUpload (bannerField, info) {
      const that = this
      that.$set(that.bannerUploadLoading, bannerField, true)
      new UploadFileToVOD([info.file], {
        success (fileName) {
          that.$set(that.form, bannerField, fileName[0])
          that.$set(that.bannerUploadLoading, bannerField, false)
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate(bannerField)
            }
          })
        },
        error () {
          that.$set(that.bannerUploadLoading, bannerField, false)
          that.$message.error('上传失败，请重试')
        }
      })
    },
    beforeBannerUpload (bannerField, file) {
      if (file.type.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.$set(this.bannerUploadLoading, bannerField, false)
        return false
      }
      this.$set(this.form, bannerField, '')
      this.$set(this.bannerUploadLoading, bannerField, true)
    },
    handleVideoUpload (item, info) {
      const that = this
      const videoField = item.videoUrl
      if (info.file.status === 'uploading') {
        that.$set(that.videoUploadLoading, videoField, true)
        return
      }
      that.$set(that.form, videoField, '')
      that.$set(that.videoUploadLoading, videoField, true)
      new UploadFileToVOD([info.file], {
        success (fileName) {
          that.$set(that.form, videoField, fileName[0])
          that.$set(that.videoUploadLoading, videoField, false)
          that.$set(that.videoUploadProgress, videoField, 0)
        },
        error () {
          that.$set(that.videoUploadLoading, videoField, false)
          that.$set(that.videoUploadProgress, videoField, 0)
          that.$message.error('上传失败，请重试')
        },
        vProgress (val) {
          that.$set(that.videoUploadProgress, videoField, val * 100)
        }
      })
    },
    updateType (value) {
      this.type = value
    },
    updateIsGo (value) {
      this.isJup = value
    },
    onClose () {
      this.isJup = false
      this.videoUploadProgress = buildVideoUploadProgress()
      this.open = false
      this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
    },
    cancel () {
      this.open = false
      this.reset()
    },
    getGather () {
      listVideo({ isRelease: 1 }).then(res => {
        this.listAll = res.data
      })
    },
    reset () {
      this.formType = 1
      this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
      this.bannerUploadLoading = buildBannerUploadLoading()
      this.videoUploadLoading = buildVideoUploadLoading()
      this.videoUploadProgress = buildVideoUploadProgress()
      this.form = getBaseFormFields()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBanner({ id }).then(response => {
        this.loadFormFromApi(response.data)
        this.isJup = this.form.isJump
        this.type = this.form.type
        let fal = 0
        for (const element of this.listAll) {
          if (element.id === this.form.videoId) {
            fal = 1
          }
        }
        if (fal === 0) {
          this.form.videoId = ''
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        if (!this.validateLocaleContent()) {
          return false
        }
        this.submitLoading = true
        if (this.form.id !== undefined && this.form.id !== null) {
          updateBanner(this.form).then(response => {
            this.$message.success('修改成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          addBanner(this.form).then(response => {
            this.$message.success('新增成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.locale-select-item {
  :deep(.ant-form-item-control) {
    line-height: 1.5;
  }
}

.locale-select {
  width: 520px;
  max-width: 100%;

  :deep(.ant-select-selection) {
    min-height: 40px;
    padding: 4px 8px;
    border-radius: 6px;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__choice) {
    height: 28px;
    line-height: 26px;
    margin: 2px 4px 2px 0;
    padding: 0 8px;
    border-radius: 4px;
    background: #f0f5ff;
    border-color: #d6e4ff;
    color: #2f54eb;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__rendered) {
    margin-left: 4px;
    line-height: 30px;
  }
}

.locale-block {
  padding: 12px 16px 4px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
}

.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
